$(function() {
    let $searchModal = document.querySelector('.js-search-modal'),
        $searchBtn = document.querySelector('.js-search-btn'),
        $closeSearchBtn = document.querySelector('.js-close-search-btn');

    if ($searchBtn) {
        $searchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add('ov-hidden');
            $searchModal.classList.toggle('active');
        });
    }

    if ($closeSearchBtn) {
        $closeSearchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.remove('ov-hidden');
            $searchModal.classList.remove('active');
        });
    }
});